import { VacancyDetailsDto } from '@client/api';
import i18n from 'i18next';

export const transformToExcelFormat = (data: VacancyDetailsDto[], selectedRows: Set<string>, selectedYear: number) => {
  const rows: Record<string, any>[] = [];
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];

  const colBuilding = i18n.t('vacancyCost.building', { ns: 'reporting' });
  const colPremisesCount = i18n.t('vacancyCost.premises', { ns: 'reporting' });
  const colArea = i18n.t('vacancyCost.totalArea', { ns: 'reporting' });
  const colSelectedYear = i18n.t('vacancyCost.costByYear', { ns: 'reporting', year: selectedYear });
  const colPreviousYear = i18n.t('vacancyCost.costByYear', { ns: 'reporting', year: selectedYear - 1 });
  const colAvailability = i18n.t('vacancyCost.weeksAvailable', { ns: 'reporting' });
  const colPercentChange = i18n.t('vacancyCost.percentChange', { ns: 'reporting' });

  data.forEach((building) => {
    if (selectedRows.has(building.buildingId) || selectedRows.size === 0) {
      rows.push({
        [colBuilding]: building.buildingName,
        [colPremisesCount]: building.numberOfPremises,
        [colArea]: building.areaMetric,
        [colSelectedYear]: building?.selectedYearAmount?.value,
        [colPreviousYear]: building?.previousYearAmount?.value,
        [colAvailability]: building.numberOfWeekAvailable,
        [colPercentChange]: building.changePercentage,
      });

      building.premises.forEach((premise) => {
        rows.push({
          [colBuilding]: null,
          [colPremisesCount]: premise.spaceType,
          [colArea]: premise.areaMetric,
          [colSelectedYear]: premise?.selectedYearAmount?.value,
          [colPreviousYear]: premise?.previousYearAmount?.value,
          [colAvailability]: premise.numberOfWeekAvailable,
          [colPercentChange]: premise.changePercentage,
        });
      });
    }
  });

  return rows;
};
